import { render, staticRenderFns } from "./TwofactorEditComponent.vue?vue&type=template&id=4156ac98&scoped=true"
import script from "./TwofactorEditComponent.vue?vue&type=script&lang=js"
export * from "./TwofactorEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156ac98",
  null
  
)

export default component.exports